import { useRef } from 'react';

import { resolveService } from './resolveService';

export const useService: typeof resolveService = (service, depsOverrides) => {
	type MemoizedRef =
		| { depsOverrides: undefined; result: undefined; service: undefined }
		| {
				depsOverrides: typeof depsOverrides;
				result: any;
				service: typeof service;
		  };

	const memoizedRef = useRef<MemoizedRef>({
		service: undefined,
		depsOverrides: undefined,
		result: undefined,
	});

	const memoized = memoizedRef.current;
	if (
		!memoized ||
		memoized.service !== service ||
		!areObjectsEqualShallow(memoized.depsOverrides, depsOverrides)
	) {
		memoizedRef.current.result = resolveService(service, depsOverrides);
		memoizedRef.current.depsOverrides = depsOverrides;
		memoizedRef.current.service = service;
	}
	return memoizedRef.current.result;
};

type Obj = Record<string, unknown>;

const DIFFERENT = false;
const EQUAL = true;
const areObjectsEqualShallow = (
	prevObject: Obj | undefined,
	nextObject: Obj | undefined,
): boolean => {
	if (nextObject === prevObject) {
		return EQUAL;
	}
	if (!prevObject || !nextObject) {
		return DIFFERENT;
	} else {
		const prevKeys = Object.keys(prevObject);
		const keys = Object.keys(nextObject);
		if (keys.length !== prevKeys.length) {
			return DIFFERENT;
		} else {
			for (let key of keys) {
				if (nextObject[key] !== prevObject[key]) {
					return DIFFERENT;
				}
			}
		}
		return EQUAL;
	}
};
